import { render, staticRenderFns } from "./HospitalityInitiative.vue?vue&type=template&id=c2b5639e&scoped=true&"
import script from "./HospitalityInitiative.vue?vue&type=script&lang=ts&"
export * from "./HospitalityInitiative.vue?vue&type=script&lang=ts&"
import style0 from "./HospitalityInitiative.vue?vue&type=style&index=0&id=c2b5639e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b5639e",
  null
  
)

export default component.exports